var app = angular.module('directives.breadcrumbs');
  app.directive('breadcrumbs', [
      'configs',
      '$translate',
      '$location',
      '$state',
      function(configs, $translate,
      $location, $state) {
          return {
            restrict: 'E',
            scope: {
              obj: '=',
              serv: '=',
              rec: '@'
            },
            template: require('../templates/breadcrumbs.html'),
            controller: [
              '$scope',
              '$timeout',
              '$state',
              '$location',
              'staticCategories',
              function($scope, $timeout, $state, $location, staticCategories) {
                $scope.serviceData = staticCategories.cats;
                $scope.type = 0;
                $scope.paymentPage = {
                  name: '',
                  parentName: ''
                };

                $scope.breadcrumbsFnc = function() {
                  if ($state.current.data.breadcrumbs) {
                    $scope.type = 1;
                    return $state.current.data.breadcrumbs;
                  } else
                  if ($scope.obj) {
                    $scope.type = 2;
                    findCategoryId($scope.serv);
                    $scope.paymentPage.name = $scope.obj ;
                    return false;
                  } else
                  if ($location.path() == '/cardtocard') {
                    $scope.type = 1;
                    return 'CARD2CARD.TITLE';
                  } else
                  if ($scope.rec) {
                    $scope.type = 1;
                    return $scope.rec;
                  }
                };
                if ($scope.serv && !$scope.obj) {
                  findCategoryId($scope.serv);
                }

                function findCategoryId (id) {
                  for (var i = 0; i < $scope.serviceData.length; i++) {
                    if ($scope.serviceData[i].categoryId == id) {
                      $scope.paymentPage.parentName = $scope.serviceData[i].name;
                      return;
                    }
                  }
                  //change category service 32 breadcrumb into service other
                  if (id == 32) {
                      $scope.paymentPage.parentName = 'PAYMENTS.OTHER';
                  }
                  //
                }
              }
            ]
          }
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/breadcrumbs/directives/breadcrumbs.js
 ** module id = 136
 ** module chunks = 1
 **/